import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getCalcoloPreventivo(importoState,mesiState,progettoState,assicurazioneState,brokerCode,apiPath) {
    return (dispatch) => {
        API.getAxios(apiPath).post('/preventivo/calcolo',{
            codiceBroker: brokerCode,
            importo:importoState,
            mesi:mesiState,
            progetto: progettoState,
            assicurazione: assicurazioneState
        })
        .then(response => {
            //console.log(`RESPOSNE CALCOLO PREVENTIVO: ${JSON.stringify(response.data)}`);
            dispatch({type: actionTypes.CALCOLO_PREVENTIVO, payload: response.data , importo: importoState, numeroRate: mesiState, progetto: progettoState, assicurazione: assicurazioneState });
            dispatch({type: actionTypes.LOADING_PREVENTIVO_FALSE});
        })
        .catch(errore => {
            dispatch({ type: actionTypes.ERROR_CALCOLO_PREVENTIVO, payload: errore.response.data, importo: importoState, numeroRate: mesiState, progetto: progettoState, assicurazione: assicurazioneState});
            dispatch({type: actionTypes.LOADING_PREVENTIVO_FALSE});
            if(errore.response.data.errorCode === 'generico' || errore.response.data.errorCode === 'codiceBroker'){
                message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
            }
         })
    };
}

export default getCalcoloPreventivo;